import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil, timer } from 'rxjs';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { registerables } from 'chart.js';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-fleetdiag-fullscreen-chart',
  templateUrl: './fleetdiag-fullscreen-chart.component.html',
  styleUrls: ['./fleetdiag-fullscreen-chart.component.css']
})

export class FleetdiagFullscreenChartComponent implements OnInit {

  obj: any;
  ctx1: any;
  label: Array<any> = [];
  datachart: Array<any> = [];

  CHART_COLORS: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  private destroy$ = new Subject<void>();
  private pointMap = new Map<string, number>();

  searchForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
    strPID: new FormControl(''),
    strUnitID: new FormControl(''),
    iFleetDiag_SystemUser: new FormControl(''),
    source: new FormControl(''),
    title: new FormControl(''),
  });

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
  ) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }

  ngOnInit(): void {
    try {
      const { id, slug, title } = this.route.snapshot.params;

      const isFleetUser = id.length < 15 && id.length > 3;
      const controlName = isFleetUser ? 'iFleetDiag_SystemUser' : 'strUnitID';

      if (id) {
        this.searchForm.patchValue({
          [controlName]: id,
          strPID: slug,
          title: title.replace(/-/g, ' '),
          source: isFleetUser ? 'users' : 'car-info'
        });

        this._otherService.Showspinner();
        this.fetchData();

      }
    } catch (error) {
      this._tooltip.showError('IMEI شناسایی نشد');
    }
  }

  async fetchData() {
    const model = this._otherService.stringNumberToNumber(this.searchForm.value);

    const endpoint =
      this.searchForm.value.source === 'users'
        ? 'FleetDiag_PID_Chart4FleetDiag'
        : 'FleetDiag_PID_Chart';

    const response = JSON.parse(
      (await axios.post(endpoint, model)).data.toString()
    );

    this._otherService.nonespinner();

    if (response.ISSessionExpired == true) {
      this._tooltip.showError('نشست کاربری شما منقضی شده است');
      this._otherService.removeLocalStorage();
      this.router.navigate(['login'], {
        queryParams: { error: 'PID_Chart' },
      });
      return;
    }

    if (response.iResult == 0) {
      return this._tooltip.showError(response.strError);
    }

    this.drawChart(response);

  }

  drawChart(resParse: any) {

    // بار اول => ساخت چارت
    if (!this.ctx1) {

      const labels = resParse.map((item: any) => item.X);
      const data = resParse.map((item: any) => Number(item.Y));

      const ctx = document.getElementById('myChart') as HTMLCanvasElement;

      this.ctx1 = new Chart(ctx, {

        type: 'line',

        data: {
          labels,
          datasets: [
            {
              data,
              borderColor: '#00ffff',
              backgroundColor: '#00ffff10',
              fill: true,
              tension: 0.4,
              pointBackgroundColor: '#00ffff',
              pointBorderColor: '#00ffff',
              pointRadius: 3
            }
          ]
        },

        options: {
          responsive: true,
          interaction: {
            mode: 'nearest',
            intersect: false
          },

          plugins: {
            legend: {
              display: false
            },

            tooltip: {
              enabled: true,
              backgroundColor: '#0b0f14',
              borderColor: '#00ffff',
              borderWidth: 1,
              titleColor: '#00ffff',
              bodyColor: '#ffffff',
              titleFont: {
                family: 'bYekan',
                size: 13
              },
              bodyFont: {
                family: 'bYekan',
                size: 12
              },
              padding: 10,
              displayColors: false,
              callbacks: {
                label: (context) => {
                  return `مقدار: ${context.parsed.y}`;
                }
              }
            },

            zoom: {
              zoom: {
                wheel: { enabled: true },
                pinch: { enabled: true },
                mode: 'x'
              }
            }
          },

          scales: {

            x: {
              ticks: {
                color: '#ffffffa9',
                font: {
                  family: 'bYekan',
                  size: 12
                }
              },
              grid: {
                color: '#ffffff10',
                borderColor: '#ffffff60',
                borderWidth: 1
              }
            },

            y: {
              ticks: {
                color: '#ffffffa9',
                font: {
                  family: 'bYekan',
                  size: 12
                }
              },
              grid: {
                color: '#ffffff10',
                borderColor: '#ffffff60',
                borderWidth: 1
              }
            }
          }
        }
      });

      // ساخت ایندکس برای جستجوی سریع
      resParse.forEach((item: any, index: number) => {
        this.pointMap.set(item.X, index);
      });

      return;
    }

    // دفعات بعدی => فقط آپدیت
    let hasChanges = false;

    resParse.forEach((item: any) => {

      const index = this.pointMap.get(item.X);
      const value = Number(item.Y);

      // اگر وجود نداشت => اضافه کن
      if (index === undefined) {

        this.ctx1.data.labels.push(item.X);

        this.ctx1.data.datasets[0].data.push(value);

        this.pointMap.set(
          item.X,
          this.ctx1.data.labels.length - 1
        );

        hasChanges = true;

        return;
      }

      // اگر وجود داشت ولی مقدار تغییر کرده
      const currentValue =
        Number(this.ctx1.data.datasets[0].data[index]);

      if (currentValue !== value) {

        this.ctx1.data.datasets[0].data[index] = value;

        hasChanges = true;
      }

    });

    if (hasChanges) {
      this.ctx1.update('none');
    }
  }

}
